import React from 'react';
import CodeEditor from './Editor/CodeEditor';
import LatexRenderer from './Output/LatexRenderer';
import OutputRenderer from './Output/OutputRenderer';
import EditorControls from './Editor/EditorControls';
import OutputControls from './Output/OutputControls';
import FunctionBar from './Editor/FunctionBar';
import ConnectionStatus from './Common/ConnectionStatus';
import ApiUrlConfig from './Common/ApiUrlConfig';

const MainCalculator = ({ showToast }) => {
  console.log('🏗️ MainCalculator rendering');
  
  return (
    <div className="app-container">
      <div className="editor-panel">
        <div className="panel-header">
          <h2>🔢 ./math Input</h2>
          <EditorControls />
        </div>
        <FunctionBar />
        <CodeEditor />
      </div>
      
      <div className="output-panel">
        <div className="panel-header">
          <h2>📊 LaTeX Output</h2>
          <OutputControls />
        </div>
        <LatexRenderer />
      </div>
    </div>
  );
};

export default MainCalculator;